var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2H6.5C4.84 2 3.5 3.33 3.5 4.97V15.88C3.5 17.52 4.84 18.86 6.5 18.86H7.26C8.05 18.86 8.82 19.17 9.38 19.73L11.09 21.42C11.87 22.19 13.13 22.19 13.91 21.42L15.62 19.73C16.18 19.17 16.95 18.86 17.74 18.86H18.5C20.16 18.86 21.5 17.52 21.5 15.88V4.97C21.5 3.33 20.16 2 18.5 2ZM12.5 5.55C13.58 5.55 14.45 6.43 14.45 7.5C14.45 8.56 13.61 9.41 12.57 9.45C12.53 9.45 12.47 9.45 12.42 9.45C11.37 9.41 10.54 8.56 10.54 7.5C10.55 6.43 11.42 5.55 12.5 5.55ZM15.25 14.69C13.74 15.7 11.26 15.7 9.75 14.69C8.42 13.81 8.42 12.35 9.75 11.46C11.27 10.45 13.75 10.45 15.25 11.46C16.58 12.35 16.58 13.8 15.25 14.69Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRole);
export default __webpack_public_path__ + "static/media/add-role.3854cb048da5f9bdc1f8f8590ad8aa01.svg";
export { ForwardRef as ReactComponent };